import { useCallback } from 'react';

import { PossibleStatisticCategories } from '@/resources/constantsStatistic';
import { CHART_COLORS_LEFT } from '@/resources/constants';

import useStatisticCategoriesOptions from '@/hooks/useStatisticCategoriesOptions';

const useGetParameterColor = () => {
  const { statisticCategoriesOptions } = useStatisticCategoriesOptions();

  const getParameterColor = useCallback(
    (name: PossibleStatisticCategories) => {
      const colors = CHART_COLORS_LEFT;
      const index = statisticCategoriesOptions.findIndex((a) => a.value === name);

      return colors[index] || 'black';
    },
    [statisticCategoriesOptions],
  );

  return { getParameterColor };
};

export default useGetParameterColor;
